import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'

import Api from '@/plugins/api'
import Delay from '@/plugins/delay'

import VeeValidate, { Validator } from 'vee-validate'
const ja = require('vee-validate/dist/locale/ja')

Vue.config.productionTip = false

Object.defineProperty(Vue.prototype, '$state', {
  get(this: Vue) {
    return this.$store.state
  }
})

Validator.localize('ja', ja)
Vue.use(VeeValidate, {
  locale: 'ja'
})
Vue.use(Api, { router, store })
Vue.use(Delay, { store })

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
